import { createI18n } from 'vue-i18n';

/**
 * Load locale messages
 *
 * The loaded `JSON` locale messages is pre-compiled by `@intlify/vue-i18n-loader`, which is integrated into `vue-cli-plugin-i18n`.
 * See: https://github.com/intlify/vue-i18n-loader#rocket-i18n-resource-pre-compilation
 */
function loadLocaleMessages() {
  const locales = require.context('./lang', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

const messages = loadLocaleMessages();

const normalizeLocale = (value) => {
  const raw = String(value || '').trim();
  if (!raw) return '';
  return raw.replace('_', '-');
};

const resolveLocale = (requested, availableLocales, fallback = 'en') => {
  const normalized = normalizeLocale(requested);
  if (!normalized) return fallback;

  if (availableLocales.includes(normalized)) return normalized;

  const lang = normalized.split('-')[0];
  if (lang && availableLocales.includes(lang)) return lang;

  const caseInsensitiveExact = availableLocales.find(
    (loc) => String(loc).toLowerCase() === normalized.toLowerCase(),
  );
  if (caseInsensitiveExact) return caseInsensitiveExact;

  const caseInsensitiveLang = availableLocales.find(
    (loc) => String(loc).toLowerCase() === lang.toLowerCase(),
  );
  if (caseInsensitiveLang) return caseInsensitiveLang;

  return fallback;
};

const availableLocales = Object.keys(messages);
const configuredLocale = process.env.VUE_APP_I18N_LOCALE || 'en';
const configuredFallbackLocale = process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en';
const resolvedFallbackLocale = resolveLocale(configuredFallbackLocale, availableLocales, 'en');
const resolvedLocale = resolveLocale(configuredLocale, availableLocales, resolvedFallbackLocale);

const setDateTimeFormats = {
  short: {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  },
  long: {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    weekday: 'long',
    hour: 'numeric',
    minute: 'numeric',
  },
};

const dateTimeFormats = {
  en: setDateTimeFormats,
  es: setDateTimeFormats,
  de: setDateTimeFormats,
  'en-GB': setDateTimeFormats,
};

export default createI18n({
  locale: resolvedLocale,
  fallbackLocale: resolvedFallbackLocale,
  messages,
  dateTimeFormats,
});